import { Button } from "@mui/material";
import styled from "styled-components";

import { motion } from "framer-motion";
import theme from "../../styles/styleTheme";
import { isMobile } from "react-device-detect";
import PremiumDetails from "./PremiumDetails";
import { useTranslation } from "react-i18next";

type PremiumAccountCardProps = {
  handleAnimate: () => void;
  showPremiumForm: boolean;
};

const PremiumAccountCard = ({
  handleAnimate,
  showPremiumForm,
}: PremiumAccountCardProps) => {
  const { t } = useTranslation();

  return (
    <StyledCard
      id="target"
      $showPremiumForm={showPremiumForm}
      as={motion.div}
      whileHover={showPremiumForm ? {} : { scale: 1.02 }}
      $isMobile={isMobile}
    >
      <PremiumDetails label={true} />
      {!showPremiumForm && (
        <Button
          variant="contained"
          sx={{ borderRadius: 5, width: "100%", marginTop: 2 }}
          onClick={() => handleAnimate()}
        >
          {t("profile.signup")}
        </Button>
      )}
    </StyledCard>
  );
};

export const FeaturesList = styled.ul`
  list-style: none;
`;

export const FeaturesListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
`;

const StyledCard = styled.div<{
  $showPremiumForm: boolean;
  id: string;
  children: React.ReactNode;
  $isMobile: boolean;
}>`
  padding: 30px;
  width: ${({ $isMobile }) => ($isMobile ? "100%" : "")};
  border-radius: 20px;
  background-color: ${({ $showPremiumForm }) =>
    $showPremiumForm ? "" : `#fff`};
  box-shadow: ${({ $showPremiumForm }) =>
    $showPremiumForm ? "" : `0px 0px 12px 0px ${theme.palette.primary.main}`};
`;
export default PremiumAccountCard;
